import type { Router } from 'next/router'

export const isPaymentDialogInQuery = (query: Router['query']) => {
  const hasPaymentEntityIdInQuery = 'reconciliation_item_id' in query

  return hasPaymentEntityIdInQuery
}
